import "../auth.scss";
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Input } from "common/InputForm";
import { loginApi } from "services/auth";
import { toastMessage } from "utils/toastMessage";
import useButtonLoader from "../../../hooks/useButtonLoader";
import usePasswordToggle from "../../../hooks/usePasswordToggle";
import { authImage, LogoImg2 } from "../../../assets/images";
import { auth } from "validation/schema/auth";
import { ValidateInput } from "validation/index";
import { getToken } from "config/axiosInstance";

// ------permission
import { usePermission } from "context/permission_context";
import { requestForToken } from "config/firebase";

const LoginPage = ({ setSteps, data, setData }) => {
  const navigationRoute = useNavigate();
  const [error, setError] = useState({ email: "", password: "" });
  const [buttonLoader, setButtonLoader] = useButtonLoader("Login");
  const [inputType, icon] = usePasswordToggle();
  const [deviceToken, setDeviceToken] = useState('')
  // -------permission
  const { setPermission } = usePermission();

  // on change handler
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  // Input Validtion
  const validation = () => {
    const { errors, status } = ValidateInput(data, "loginSchema", auth, null);
    setError(errors);
    return status;
  };

   useEffect(() => {
    const setTokenFun = async () => {
      const deviceToken = await requestForToken();
      // console.log({ deviceToken });
      setDeviceToken(deviceToken);

      // console.log("deviceToken:---------->", deviceToken);
    };
    setTokenFun();
  }, []);

  // --------------permission
  function mapMenuRoles(dataArray) {
    return dataArray.reduce((acc, item) => {
      acc[item.menuslug] = item.roles;
      return acc;
    }, {});
  }
 
  const toDashboardMiddleware = (responseData) => {
    // ------------set permission
    console.log('responseData?.data', responseData?.data)
    setPermission(mapMenuRoles(responseData?.data?.permission || []));

    localStorage.setItem(
      "cashsurvey_admin",
      JSON.stringify(responseData?.data.token)
    );
    localStorage.setItem(
      "admin-detail",
      JSON.stringify(responseData?.data.admin)
    );
    localStorage.setItem(
      "admin-permission",
      JSON.stringify(mapMenuRoles(responseData?.data?.permission || []))
    );
    toastMessage(responseData?.message, "success", "loginToDashboard");
    navigationRoute("/dashboard");
  };

  // Login Handler function
  const loginHandler = async (e) => {
    e.preventDefault();
    if (validation()) {
      console.log("Validation is passed");
      try {
        const { otp, ...rest } = data;
        setButtonLoader(true);
        const { data: responseData, status } = await loginApi({ ...rest, fcmToken: deviceToken });
        if (status === 200) {
          // console.log("responseData:----------->", responseData);
          // toastMessage(responseData?.message, "success", "login");
          toDashboardMiddleware(responseData);
          setSteps(2);
        }
      } catch (e) {
        console.log("error", e);
      } finally {
        setButtonLoader(false);
      }
    }
  };

  useEffect(() => {
    if (getToken()) {
      navigationRoute("/dashboard");
    }
  }, []);

  return (
    <>
      <div className="auth_section">
        <div className="image_section">
          <img src={authImage} alt="" />
        </div>
        <form>
          <div className="form_title">
            <h3>Login</h3>
            <p>
              Login to your registered account to manage your business and check
              the business updates.
            </p>
          </div>
          <div className="content">
            <div className="form_field">
              <Input
                label="Email"
                placeholder="Enter Email"
                name="email"
                maxLength={40}
                value={data?.email}
                onChange={handleInputChange}
                error={error?.email}
                extraError={error?.emailErr}
              />
            </div>
            <div className="form_field has_icon">
              <Input
                className={"form-control input"}
                type={inputType}
                label="Password"
                placeholder="Enter Password"
                name="password"
                maxLength={40}
                value={data?.password}
                onChange={handleInputChange}
                error={error?.password}
              />
              <span className="password_icons">{icon}</span>
            </div>
            <div className="reminder">
              <label>
                <input type="checkbox" />
                <span>Remind me</span>
              </label>
              <Link to="" onClick={() => setSteps(3)}>
                Forgot Password?
              </Link>
            </div>
            <div className="button_wrap">
              <button
                type="button"
                ref={buttonLoader}
                className="w-100 button"
                onClick={loginHandler}
              >
                Login
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default LoginPage;
